//@ts-ignore
//This module is declared with 'export =', and can only be used with a default import when using the 'esModuleInterop' flag.
import React, {ReactElement} from "react";
import {useLocation} from "react-router-dom";

export default function Index(): ReactElement | null {
    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }
    // Variables
    const query = useQuery();
    return (
        <iframe src={`${window.userprofile.url}/${window.userprofile.path.connect}?${query}`}></iframe>
    );
}
